export default "__VITE_PUBLIC_ASSET__0ba569cf__"